import React from "react";

const FormField = ({ label, hint, error, showError = false, valid = false, required = false, children, style }) => (
  <div className="mb-4" style={style}>
    {label && (
      <label className="block text-sm font-semibold mb-1.5">
        {label}
        {required && <span className="text-[var(--danger)]"> *</span>}
      </label>
    )}
    {children}
    {hint && !showError && <div className="text-xs text-[var(--muted)] mt-1">{hint}</div>}
    {showError && error && <div className="text-xs text-[var(--danger)] mt-1">{error}</div>}
  </div>
);

export default FormField;
